import type { ReactNode } from 'react'

import Page from 'components/Page'
import LogInToAccess from 'src/pageContainers/LogInToAccess'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { isLoggedInSelector } from 'store/modules/user/selectors'

import classes from './styles.module.scss'

type Props = {
  children: ReactNode | (() => ReactNode)
}

export default function MyGamesLayout(props: Props) {
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isAppInitialized = useAppSelector(isAppInitializedSelector)

  if (!isAppInitialized) {
    return null
  }

  if (isLoggedIn) {
    return (
      <Page rootClassName={classes.root} className={classes.content}>
        {typeof props.children === 'function' ? props.children() : props.children}
      </Page>
    )
  }

  return <LogInToAccess classNameRoot={classes.root} classNameContent={classes.content} />
}
